import { DeleteRequest, GetListRequest, GetListResponse } from "./api.model";

export type VenueGetListRequest = GetListRequest<VenueGetListRequestFilter>;
export type VenueGetListResponse = GetListResponse<Venue>;
export type VenueDeleteRequest = DeleteRequest;

export interface VenueGetListRequestFilter {
  /** @format int64 */
  refOrganization_Id?: number | null;
  name?: string | null;
  description?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  addressLine3?: string | null;
  addressLine4?: string | null;
  email?: string | null;
  phoneAreaCode?: string | null;
  phone?: string | null;
  website?: string | null;
  locationMap?: string | null;
  layoutType?: VenueDetailsLayoutType;

  /** @format int64 */
  numberofBlocks?: number | null;
  tags?: string | null;
  isEnabled?: boolean | null;

  /** @format int64 */
  sortOrder?: number | null;
}

export type VenueDetailsLayoutType = 1 | 2 | 3;

export interface Venue {
  /** @format int64 */
  refOrganization_Id?: number | null;
  name?: string | null;
  description?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  addressLine3?: string | null;
  addressLine4?: string | null;
  email?: string | null;
  phoneAreaCode?: string | null;
  phone?: string | null;
  website?: string | null;
  locationMap?: string | null;
  layoutType?: VenueDetailsLayoutType;

  /** @format int64 */
  numberofBlocks?: number | null;
  tags?: string | null;
  isEnabled?: boolean | null;

  /** @format int64 */
  sortOrder?: number | null;

  /** @format int64 */
  id?: number;

  /** @format byte */
  system_RowVersion?: string | null;
}

export interface VenueInsertRequest {
  /** @format int64 */
  refOrganization_Id?: number | null;
  name?: string | null;
  description?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  addressLine3?: string | null;
  addressLine4?: string | null;
  email?: string | null;
  phoneAreaCode?: string | null;
  phone?: string | null;
  website?: string | null;
  locationMap?: string | null;
  layoutType?: VenueDetailsLayoutType;

  /** @format int64 */
  numberofBlocks?: number | null;
  tags?: string | null;
  isEnabled?: boolean | null;

  /** @format int64 */
  sortOrder?: number | null;
}
